import { render, staticRenderFns } from "./PolicyEventOptions.vue?vue&type=template&id=681bf6ee"
import script from "./PolicyEventOptions.vue?vue&type=script&lang=js"
export * from "./PolicyEventOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports